import { identityService } from "../profile/identityService_v2.js";
import { matchService } from "./matchService_v2.js";
import { colors } from "../colors_v2.js";
import { escapeHtml } from "../escapeHtml_v2.js";

const generateStateHTML = (stateValue) => {
  const doubleColor = colors.getGameColor("double");
  if (typeof stateValue === "undefined") {
    stateValue = "n/a";
  }
  stateValue = matchService.getFriendlyState(stateValue);
  return `<div class="cardState vertical-LeftSide" style="background:${doubleColor};">${stateValue.toUpperCase()}</div>`;
};

import { utilsApp } from "../utils-app_v2.js";

const generateHTML = (match) => {
  const doubleColor = colors.getGameColor("double");
  const turnDiv = `<div class="matchCardPill" style="background:${doubleColor};">TURN</div>`;
  const winnerDiv = `<div class="matchCardPill" style="background:${doubleColor};">WINNER</div>`;

  // SECURITY: player names are user-entered, so they're escaped.
  let p1Turn = escapeHtml(match.p1Name);

  if (match.p1Name != "computer" && match.p1Name != "waiting") {
    let p1UserID = match.p1UserID;
    let p1NamePart = identityService.parseName(match.p1Name);
    p1Turn = `${escapeHtml(p1NamePart)} <br><span class='pAUserIDColor'>(${escapeHtml(p1UserID)})</span>`;
  }
  let p2Turn = escapeHtml(match.p2Name);
  if (match.p2Name != "computer" && match.p2Name != "waiting") {
    let p2UserID = match.p2UserID;
    let p2NamePart = identityService.parseName(match.p2Name);
    p2Turn = `${escapeHtml(p2NamePart)} <br><span class='pAUserIDColor'>(${escapeHtml(p2UserID)})</span>`;
  }
  // active matches
  if (match.active === "active") {
    if (match.turn === match.p1UserID) {
      p1Turn = "<em>" + p1Turn + "</em>";
      p1Turn = p1Turn + turnDiv;
    } else {
      p1Turn = p1Turn + `<br>`;
    }
    if (match.turn === match.p2UserID) {
      p2Turn = "<em>" + p2Turn + "</em>";
      p2Turn = p2Turn + turnDiv;
    } else {
      p2Turn = p2Turn + `<br>`;
    }
  }

  // inActive
  if (match.active === "inActive") {
    if (identityService.parseUserID(match.winnerName) === match.p1UserID) {
      p1Turn = "<em>" + p1Turn + "</em>";
      p1Turn = p1Turn + winnerDiv;
    } else {
      p1Turn = p1Turn + `<br>`;
    }
    if (identityService.parseUserID(match.winnerName) === match.p2UserID) {
      p2Turn = "<em>" + p2Turn + "</em>";
      p2Turn = p2Turn + winnerDiv;
    } else {
      p2Turn = p2Turn + `<br>`;
    }
  }

  p1Turn += `<div>${escapeHtml(match.p1Score)}</div>`;
  p2Turn += `<div>${escapeHtml(match.p2Score)}</div>`;

  let messageHtml = "";
  if (match.message && match.message.trim().length > 0) {
    // Sanitize message to prevent XSS - escape HTML special characters
    const sanitizedMessage = utilsApp.sanitizeMessage(match.message);
    // Message in Courier, in quotes, with normal weight
    const formattedMessage = `<span style="font-family: Courier New, monospace; font-weight: normal;">"${sanitizedMessage}"</span>`;
    // Add splainer with info about invitation message
    const messageSplainer = `<div id="cardMessageSplainer" class="i">ⓘ</div>`;
    messageHtml = `<div class="cardMessage">${formattedMessage} ${messageSplainer}</div>`;
  }

  return `
    <div class="matchCard" id="recentMatch${escapeHtml(match.matchID)}" style="background-color:${colors.getGameColor("tip")}">
      <div class="matchCardRow">
        ${generateStateHTML(match.state)} 
        <div class="cardItem">${p1Turn}</div> 
        <div class="cardVSItem">vs</div>
        <div class="cardItem">${p2Turn}</div>
        <div class="cardDate vertical-RightSide">${new Date(
          match.lastMove * 1000,
        ).toLocaleDateString("en-US")}</div>
      </div>
      ${messageHtml}
    </div>
  `;
};

export const matchCard = {
  generateHTML,
};
